export enum SPACE_TYPES {
  BASKET = "basket",
  ATHLETICS = "athletics",
  SOCCER = "soccer",
  RUGBY_UNION = "rugby-union",
  VOLLER_BALL = "volley-ball",
  GYM = "gym",
}

export enum SOCCER_ROLES {
  GOALKEEPER = "goalkeeper",
  DEFENDER = "defender",
  MIDFIELDER = "midfielder",
  WINGER = "winger",
  FORWARD = "forward",
}

export enum BASKET__ROLES {
  POINT_GUARD = "point-guard",
  SHOOTING_GUARD = "shooting-guard",
  SMALL_FORWARD = "small-forward",
  POWER_FORWARD = "power-forward",
  CENTER = "center",
}
export enum RUGBY_UNION_ROLES {
  PROP = "prop",
  HOOKER = "hooker",
  LOCK = "lock",
  FLANKER = "flanker",
  NUMBER_8 = "number-8",
  SCRUM_HALF = "scrum-half",
  CENTER = "Center",
  RIGHT_WING = "right-wing",
  FULLBACK = "fullback",
}

export enum VOLLEYBALL_ROLES {
  SETTER = "setter",
  OPPOSITE_HITTER = "opposite-hitter",
  OUTSIDE_HITTER = "outside-hitter",
  MIDDLE_BLOCKER = "middle-blocker",
  LIBERO = "libero",
}

export enum ATHLETE_ROLES {
  SPRINTER_100 = "sprinter-100", // Velocista 100 metri
  SPRINTER_200 = "sprinter-200", // Velocista 200 metri
  SPRINTER_400 = "sprinter-400", // Velocista 400 metri
  MIDDLE_DISTANCE_800 = "middle-distance-800", // Corridore 800 metri
  MIDDLE_DISTANCE_1500 = "middle-distance-1500", // Corridore 1500 metri
  MIDDLE_DISTANCE_3000 = "middle-distance-3000", // Corridore 3000 metri
  HURDLER_100 = "hurdler-100", // Ostacolista 100 metri (donne)
  HURDLER_110 = "hurdler-110", // Ostacolista 110 metri (uomini)
  HURDLER_400 = "hurdler-400", // Ostacolista 400 metri
  LONG_DISTANCE_5000 = "long-distance-5000", // Corridore 5000 metri
  LONG_DISTANCE_10000 = "long-distance-10000", // Corridore 10000 metri
  MARATHON = "marathon", // Maratoneta
  RELAY_4X100 = "relay-4x100", // Staffetta 4x100 metri
  RELAY_4X400 = "relay-4x400", // Staffetta 4x400 metri
  HIGH_JUMPER = "high-jumper", // Saltatore in alto
  LONG_JUMPER = "long-jumper", // Saltatore in lungo
  TRIPLE_JUMPER = "triple-jumper", // Saltatore triplo
  POLE_VAULTER = "pole-vaulter", // Saltatore con l’asta
  SHOT_PUTTER = "shot-putter", // Lanciatore del peso
  DISCUS_THROWER = "discus-thrower", // Lanciatore del disco
  JAVELIN_THROWER = "javelin-thrower", // Lanciatore del giavellotto
  HAMMER_THROWER = "hammer-thrower", // Lanciatore del martello
}

export enum GYM_ROLES {
  POWERLIFTER = "powerlifter",
  BODYBUILDER = "bodybuilder",
  CROSSFIT_ATHLETE = "crossfit-athlete",
  FUNCTIONAL_ATHLETE = "functional-athlete",
  CARDIO_ATHLETE = "cardio-athlete",
  GENERAL = "general",
}

export enum GYM_LEVELS {
  BEGINNER = "beginner",
  INTERMEDIATE = "intermediate",
  ADVANCED = "advanced",
  COMPETITIVE = "competitive",
}

export enum SPACE_GENDERS {
  MALE = "male",
  FEMALE = "female",
  MIXED = "mixed",
}

export enum SOCCER_LEVELS {
  UNDER_6 = "under-6",
  UNDER_7 = "under-7",
  UNDER_8 = "under-8",
  UNDER_9 = "under-9",
  UNDER_10 = "under-10",
  UNDER_11 = "under-11",
  UNDER_12 = "under-12",
  UNDER_13 = "under-13",
  UNDER_14 = "under-14",
  UNDER_15 = "under-15",
  UNDER_16 = "under-16",
  UNDER_17 = "under-17",
  UNDER_18 = "under-18",
  UNDER_19 = "under-19",
  UNDER_20 = "under-20",
  UNDER_21 = "under-21",
  UNDER_23 = "under-23",
  FIRST_TEAM = "first-team", // Over 18
}

export enum BASKET_LEVELS {
  SQUIRRELS_DRAGONFLIES = "squirrels-dragonflies", // 5–7 years
  EAGLETS_GAZELLES = "eaglets-gazelles", // 8–10 years
  BEGINNERS = "beginners", // 11 years
  UNDER_13 = "under-13", // 12–13 years
  UNDER_14 = "under-14", // 13–14 years
  UNDER_15 = "under-15", // 14–15 years
  UNDER_16 = "under-16", // 15–16 years
  UNDER_17_18 = "under-17-18", // 16–18 years
  UNDER_19_20 = "under-19-20", // 18–20 years
  FIRST_TEAM = "first-team", // Over 18
}

export enum VOLLEYBALL_LEVELS {
  S3_WHITE = "s3-white", // 6–7 years
  S3_GREEN = "s3-green", // 8–9 years
  S3_RED = "s3-red", // 10–11 years
  UNDER_12 = "under-12", // 11–12 years
  UNDER_13_14 = "under-13-14", // 12–14 years
  UNDER_15_16 = "under-15-16", // 14–16 years
  UNDER_17_18 = "under-17-18", // 16–18 years
  UNDER_19_20 = "under-19-20", // 18–20 years
  FIRST_TEAM = "first-team", // Over 18
}

export enum RUGBY_UNION_LEVELS {
  UNDER_5_7_9 = "under-5-7-9", // 4-9 years
  UNDER_11 = "under-11", // 10-11 years
  UNDER_13 = "under-13", // 12-13 years
  UNDER_15 = "under-15", // 14-15 years
  UNDER_17 = "under-17", // 16-17 years
  UNDER_19 = "under-19", // 18-19 years
  FIRST_TEAM = "first-team", // over 18
}

export enum ATHLETE_LEVELS {
  BEGINNERS = "beginners", // 6-11 years
  BOYS = "boys", // 12-13 years
  CADETS = "cadets", // 14-15 years
  JUNIORS = "juniors", // 16-17 years
  JUNIORES = "juniores", // 18-19 years
  PROMISES = "promises", // 20-22 years
  SENIORS_ABSOLUTE = "seniores-absolute", // over 23 years
}

export const ROLES_BY_SPORT = {
  [SPACE_TYPES.ATHLETICS]: ATHLETE_ROLES,
  [SPACE_TYPES.SOCCER]: SOCCER_ROLES,
  [SPACE_TYPES.BASKET]: BASKET__ROLES,
  [SPACE_TYPES.RUGBY_UNION]: RUGBY_UNION_ROLES,
  [SPACE_TYPES.VOLLER_BALL]: VOLLEYBALL_ROLES,
  [SPACE_TYPES.GYM]: GYM_ROLES,
};

export const LEVELS_BY_SPORT = {
  [SPACE_TYPES.ATHLETICS]: ATHLETE_LEVELS,
  [SPACE_TYPES.SOCCER]: SOCCER_LEVELS,
  [SPACE_TYPES.BASKET]: BASKET_LEVELS,
  [SPACE_TYPES.RUGBY_UNION]: RUGBY_UNION_LEVELS,
  [SPACE_TYPES.VOLLER_BALL]: VOLLEYBALL_LEVELS,
  [SPACE_TYPES.GYM]: GYM_LEVELS,
};
